export const NOTIFICATION_CHANNELS = [
  {
    id: "email",
    name: "Email",
    icon: "Mail",
  },
  {
    id: "sms",
    name: "SMS",
    icon: "MessageSquare",
  },
  {
    id: "whatsapp",
    name: "WhatsApp",
    icon: "Send",
  },
  
] as const;
